import React, { useContext } from "react";
import { Segment, Tab } from "semantic-ui-react";
import CompanyInfo from "./CompanyInfo";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import PhotoUploadWidget from "../../../../app/common/photoUpload/PhotoUploadWidget";
import BreadcrumbContainer from "../../../../app/common/breadcrumb/BreadcrumbContainer";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import NotificationSignature from "./NotificationSignature";

interface IProps {
  sections: any[];
}

const DashboardCompany: React.FC<IProps> = ({ sections }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { loadBroker } = rootStore.companyStore;

  const panes = [
    {
      menuItem: "Datos básicos",
      render: () => (
        <Tab.Pane>
          <CompanyInfo />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Logo",
      render: () => (
        <Tab.Pane>
          <PhotoUploadWidget />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Firma notificaciones",
      render: () => (
        <Tab.Pane>
          <NotificationSignature/>
        </Tab.Pane>
      ),
    },
  ];

  document.title = "Mi Empresa";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Mi empresa"
        sections={sections}
      />
      <Segment >
        <div className="configurationContent">
          {!loadBroker ? (
            <LoadingComponent content="Cargando informacíon" />
          ) : (
            <Tab panes={panes} />
          )}
        </div>
      </Segment>
    </div>
  );
};

export default observer(DashboardCompany);
